/*
 * App state modifier - Action types
 */


/**
 * General - App State related constants
 */
export const START_LOGIN = 'START_LOGIN'
export const START_QUIZ = 'START_QUIZ'

/**
 * Possible app states
 */
export const AppStates = {
  INITIAL: 'INITIAL',
  LOGIN: 'LOGIN',
  QUIZ: 'QUIZ',
  RESULTS: 'RESULTS'
}

/*
 * App state setters 
 */
export function startLogin() {
  return { type: START_LOGIN };
}

export function startQuiz() {
  return { type: START_QUIZ };
}




// WEBPACK FOOTER //
// ./src/components/store/actions/appstate.js